import React from "react";
import PropTypes from "prop-types";
import ReactHtmlParser from "react-html-parser";
import { translate, getBlackAsterisk } from "application/functions";
import { isNil, isEmpty, contains } from "ramda";

const CheckBoxField = (props) => {
  const {
    errors,
    register,
    locale,
    field,
    required,
    isSubmitted,
    label,
    handleGermanChecks,
  } = props;

  const checkboxRequired = translate("checkbox.required", locale);

  const validateCheckBox = (value) => {
    if (required) {
      return value === true || checkboxRequired;
    }
    return true;
  };

  return (
    <div className="field-creator__checkbox-container-with-error">
      <div className="field-creator__checkbox-container">
        <label className="field-creator__checkbox-row">
          <input
            name={field}
            type="checkbox"
            ref={register({ validate: (value) => validateCheckBox(value) })}
            onChange={() => handleGermanChecks && handleGermanChecks(field)}
          />
          <span className="checkmark"></span>
          <div style={{ fontSize: "12px" }}>{ReactHtmlParser(label)}</div>
        </label>
      </div>
      {errors[field] && isSubmitted && (
        <div className="forms__error-message--checkbox">
          {errors[field].message}
        </div>
      )}
    </div>
  );
};

CheckBoxField.propTypes = {
  register: PropTypes.any,
  errors: PropTypes.any,
  locale: PropTypes.string,
  field: PropTypes.string,
  required: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  label: PropTypes.string,
  handleGermanChecks: PropTypes.func,
};

export default CheckBoxField;
